import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Error from '../error/Error';
import * as classes from './TextArea.module.scss';

const TextArea = forwardRef(({ id, value, onChange, label, error, ...props }, ref) => (
  <div>
    <label htmlFor={id} className={classes.textareaLabel}>
      {label}
    </label>

    <textarea id={id} value={value} onChange={onChange} className={classes.textarea} ref={ref} {...props} />

    {error && <Error>{error?.message}</Error>}
  </div>
));
TextArea.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.node,
  error: PropTypes.object
};

export default TextArea;
